import axios from 'axios'

export const PetsService = {
    loadPets: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/pets')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    },
    createPet: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.post('/pets', payload)
                    .then((response) => {
                        if (response.status === 201) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    savePet: (payload) => {
        return new Promise(
            function (resolve, reject) {
                axios.put('/pets/' + payload.id, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 200: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            }
        )
    },
    deletePet: (id) => {
        return new Promise(
            function (resolve, reject) {
                axios.delete('/pets/' + id)
                    .then((response) => {
                        if (response.status === 204) {
                            resolve(response.data)
                        } else {
                            reject(new Error('http status code other than 204: ' + response.status))
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        reject(error)
                    })
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/pets-service.js